import { toast } from 'react-toastify';
import { t } from 'i18next'
import { Trans } from 'react-i18next';

export default function refund(response:any) {
    const qnty = new Intl.NumberFormat('ru-RU').format(Math.floor(response?.data?.refunded))
    if (response?.status===200)
        return toast.success(<Trans
            i18nKey='profile.refund.status.success'
            values={{ qnty }}
            components={[<span className='fw-bold' />]}
        />)

    else if (
        [
            'REFUND_ERROR',
        ].includes(response?.data?.error)) {
            return toast.error(t(`profile.refund.status.${response?.data?.error}`))
        }

    else return toast.error(t('popup.connectionLost'))
}